// UK MOT Trade VIN rules: 17 chars, no I, O or Q.
export function normaliseVin(value = "") {
  return String(value).toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 17);
}

export function isValidVin(value) {
  return /^[A-HJ-NPR-Z0-9]{17}$/.test(normaliseVin(value));
}
